import { render, staticRenderFns } from "./BreakMessage.vue?vue&type=template&id=77c1a73c&"
import script from "./BreakMessage.vue?vue&type=script&lang=js&"
export * from "./BreakMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports